// Order Chat's composer "+" menu (group-home roster refills, PR-E; O154 F5: a dedicated
// "Refill sheet…" item). Its only item today is the refill sheet, so with the practice's
// orderChatRosterEnabled off (whoami.refillSheetsEnabled false) the whole control is
// absent — nothing shows, and the composer is exactly what it was.
//
// A menu button (WAI-ARIA APG): Enter/Space/ArrowDown open it with focus on the first
// item, Escape closes it and returns focus to the button, a click outside closes it.
import React, { useEffect, useRef, useState } from 'react';
import '../../styles/refill-sheet.css';

export function ComposerPlusMenu({ refillSheetsEnabled, onRefillSheet, disabled = false }) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const itemRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    if (itemRef.current) itemRef.current.focus();
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  if (!refillSheetsEnabled) return null;

  const close = (refocus) => {
    setOpen(false);
    if (refocus && buttonRef.current) buttonRef.current.focus();
  };
  // Focus goes back to "+" first, so the dialog opened from here returns it there.
  const choose = () => {
    setOpen(false);
    if (buttonRef.current) buttonRef.current.focus();
    if (onRefillSheet) onRefillSheet(buttonRef.current);
  };

  return (
    <div className="rs-plus" ref={wrapRef}>
      <button
        ref={buttonRef}
        type="button"
        className="rs-plus-button"
        aria-label="More ways to order"
        title="More ways to order"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="orderchat-plus-menu"
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); }
          else if (e.key === 'Escape') close(true);
        }}
      >
        <span aria-hidden="true">+</span>
      </button>
      {open && (
        <ul id="orderchat-plus-menu" className="rs-plus-menu" role="menu" aria-label="More ways to order">
          <li role="none">
            <button
              ref={itemRef}
              type="button"
              role="menuitem"
              className="rs-plus-item"
              data-action="refill-sheet"
              onClick={choose}
              onKeyDown={(e) => {
                if (e.key === 'Escape' || e.key === 'Tab') { e.preventDefault(); close(true); }
              }}
            >
              <span className="rs-plus-item-title">Refill sheet…</span>
              <span className="rs-plus-item-desc">Upload a group home's refill sheet — one draft per line</span>
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}
